import React from 'react';
import useIsMobile from '../hooks/useIsMobile';

export default function ConfirmModal({ title, message, confirmLabel, cancelLabel, confirmColor, onConfirm, onCancel }) {
  const isMobile = useIsMobile();
  if (!message) return null;

  const color = confirmColor || 'var(--red)';

  const content = (
    <>
      {title && (
        <p style={{ fontSize:18, fontWeight:800, color:'var(--text)', margin:'0 0 8px', textAlign:'center' }}>{title}</p>
      )}
      <p style={{ fontSize:14, color:'var(--text2)', margin:'0 0 24px', textAlign:'center', lineHeight:1.5 }}>{message}</p>
      <div style={{ display:'flex', gap:10 }}>
        <button onClick={onCancel}
          style={{ flex:1, padding:'13px', borderRadius:12, background:'var(--bg)', border:'1px solid var(--border)',
            color:'var(--text2)', fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer', transition:'all 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.background='var(--bg2)'}
          onMouseLeave={e => e.currentTarget.style.background='var(--bg)'}>
          {cancelLabel || 'Cancel'}
        </button>
        <button onClick={onConfirm}
          style={{ flex:1, padding:'13px', borderRadius:12, background:color, border:'none',
            color:'#fff', fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer', transition:'all 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.opacity='0.85'}
          onMouseLeave={e => e.currentTarget.style.opacity='1'}>
          {confirmLabel || 'Delete'}
        </button>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:2000, display:'flex', alignItems:'flex-end', justifyContent:'center' }}
        onClick={e => e.target === e.currentTarget && onCancel()}>
        <div style={{ background:'var(--card)', borderRadius:'20px 20px 0 0', width:'100%', padding:'10px 0 0', border:'1px solid var(--border)', borderBottom:'none', paddingBottom:'calc(88px + env(safe-area-inset-bottom))' }}>
          <div style={{ width:36, height:4, background:'var(--border)', borderRadius:2, margin:'0 auto 16px' }} />
          <div style={{ padding:'0 24px 24px' }}>{content}</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
      onClick={e => e.target === e.currentTarget && onCancel()}>
      <div style={{ background:'var(--card)', borderRadius:20, width:'100%', maxWidth:360, padding:'28px 24px', border:'1px solid var(--border)', boxShadow:'0 20px 60px rgba(0,0,0,0.5)' }}>
        {content}
      </div>
    </div>
  );
}

// Hook for easy usage: const [confirm, ConfirmDialog] = useConfirm();
// Then: if (await confirm('Delete this?')) { ... }
export function useConfirm() {
  const [state, setState] = React.useState(null);

  const confirm = (message, options = {}) => {
    return new Promise(resolve => {
      setState({ message, resolve, ...options });
    });
  };

  const ConfirmDialog = state ? (
    <ConfirmModal
      title={state.title}
      message={state.message}
      confirmLabel={state.confirmLabel}
      cancelLabel={state.cancelLabel}
      confirmColor={state.confirmColor}
      onConfirm={() => { setState(null); state.resolve(true); }}
      onCancel={() => { setState(null); state.resolve(false); }}
    />
  ) : null;

  return [confirm, ConfirmDialog];
}
